import React, { FunctionComponent, useState, useEffect } from 'react';

import { SumInsuredBuildingValueStep as CommonSumInsuredBuildingValueStep } from 'scenes/common/components/Steps';

import { HomeFullPageProps } from 'scenes/home/types';
import {
  getAgreedSumInsured,
  getAgreedSumInsuredRange,
} from 'scenes/home/selectors';
import { InsuranceName, SUM_INSURED_VALUES } from 'scenes/common/types';

import { isApiError } from 'scenes/common/helpers/apiData';
import estimatedSumInsuredApi from 'scenes/common/api/quote/estimatedSumInsured';
import { mapEstimatedSumInsuredProfile } from 'scenes/home/components/helpers/insuredProfile';

const SumInsuredBuildingStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const [valueRange, setValueRange] = useState(
    getAgreedSumInsuredRange(funnelState)
  );

  useEffect(() => {
    if (valueRange.upperLimit === '') {
      // Only goes into this block once in quote retrieve scenario due to the initial value being empty string
      const insuranceName = InsuranceName.Home;
      const estimatedSumInsuredProfile = mapEstimatedSumInsuredProfile(
        funnelState
      );
      estimatedSumInsuredApi()
        .estimateSumInsured(insuranceName, estimatedSumInsuredProfile)
        .then((sumInsured) => {
          if (!isApiError(sumInsured)) {
            const defaultMinLimit =
              SUM_INSURED_VALUES.default?.minLimit.toString() || '125000';
            const defaultMaxLimit =
              SUM_INSURED_VALUES.default?.maxLimit.toString() || '1000000';

            setValueRange({
              lowerLimit:
                sumInsured.data?.minLimit.toString() || defaultMinLimit,
              upperLimit:
                sumInsured.data?.maxLimit.toString() || defaultMaxLimit,
            });
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CommonSumInsuredBuildingValueStep
      onNext={onNext}
      defaultStateValue={getAgreedSumInsured(funnelState)}
      valueRange={valueRange}
    />
  );
};

export default SumInsuredBuildingStep;
